import moment from 'src/utils/moment';
import { markers } from './icons';

const getMarkerKey = (obj, value) => {
    if (!value) return "Regular";
    for (let k in obj) {
        if (obj[k] === value)
            return k;
    }
    return "Regular";
};


function getAudiogramData(data, isRight = true) {
    const acMarker = isRight ? markers.ac.right : markers.ac.left;
    const bcMarker = isRight ? markers.bc.right : markers.bc.left;
    const uclMarker = isRight ? markers.ucl.right : markers.ucl.left;
    return [
        {
            name: 'ac',
            lineColor: '#c91a22',
            pointStyle: 'AirCoupledRegularRight',
            isEditable: true,
            points: data && data.ac ? data.ac.measurementPoint.map(d => ({ x: d.frequency, y: d.level, icon: acMarker[d.qualification] })) : []
        },
        {
            name: 'bc',
            lineColor: '#c91a22',
            pointStyle: 'BoneCoupledRegularRight',
            isEditable: true,
            points: data && data.bc ? data.bc.measurementPoint.map(d => ({ x: d.frequency, y: d.level, icon: bcMarker[d.qualification] })) : []

        },
        {
            name: 'ucl',
            lineColor: '#c91a22',
            pointStyle: 'UclRegularRight',
            isEditable: true,
            points: data && data.ucl ? data.ucl.measurementPoint.map(d => ({ x: d.frequency, y: d.level, icon: uclMarker[d.qualification] })) : []
        }
    ];
}
function getRecdData(data) {
    return [
        {
            name: '输入的',
            lineColor: '#c91a22',
            pointStyle: 'circle',
            isEditable: true,
            points: data ? data.measurementPoints.map(d => ({ x: d.frequency, y: d.level })) : []
        },
    ];
}

export function audiogramHistory2Data(history) {
    const results = [];
    for (let data of history) {
        results.push({
            id: data.id,
            date: data.left ? data.left.creationDate : "",
            leftData: getAudiogramData(data.left, false),
            rightData: getAudiogramData(data.right),
            leftThumbnail: "",
            rightThumbnail: "",
        });
    }
    return results;
}
export function reugHistory2Data(history) {
    const results = [];
    for (let data of history) {
        results.push({
            id: data.id,
            date: data.left ? data.left.creationDate : "",
            leftData: getRecdData(data.left) || [],
            rightData: getRecdData(data.right) || [],
            leftThumbnail: "",
            rightThumbnail: "",
        });
    }
    return results;
}

export function convert2AudiogramData(id, left, right) {
    const leftAcMarker = markers?.ac?.left;
    const rightAcMarker = markers?.ac?.right;

    const leftBcMarker = markers?.bc?.left;
    const rightBcMarker = markers?.bc?.right;

    const leftUCLMarker = markers?.ucl?.left;
    const rightUCLMarker = markers?.ucl?.right;

    let result = { "Id": id };
    if (left?.length === 3) {
        result.left = {
            "creationDate": moment().format(),
            "ac": {
                "measurementCondition": {
                    "transducer": 1
                },
                "measurementPoint": left[0].points.map(p => ({
                    "frequency": p.x,
                    "level": p.y,
                    "qualification": getMarkerKey(leftAcMarker, p.icon),
                }))
            },
            "bc": {
                "measurementCondition": {
                    "transducer": 10
                },
                "measurementPoint": left[1] && left[1].points.map(p => ({
                    "frequency": p.x,
                    "level": p.y,
                    "qualification": getMarkerKey(leftBcMarker, p.icon),
                }))
            },
            "ucl": {
                "measurementCondition": {
                    "transducer": 1
                },
                "measurementPoint": left[2] && left[2].points.map(p => ({
                    "frequency": p.x,
                    "level": p.y,
                    "qualification": getMarkerKey(leftUCLMarker, p.icon),
                    "marker": p.icon,
                }))
            }
        };
    }
    if (right?.length === 3) {
        result.right = {
            "creationDate": moment().format(),
            "ac": {
                "measurementCondition": {
                    "transducer": 1
                },
                "measurementPoint": right[0] && right[0].points.map(p => ({
                    "frequency": p.x,
                    "level": p.y,
                    "qualification": getMarkerKey(rightAcMarker, p.icon),
                }))
            },
            "bc": {
                "measurementCondition": {
                    "transducer": 10
                },
                "measurementPoint": right[1] && right[1].points.map(p => ({
                    "frequency": p.x,
                    "level": p.y,
                    "qualification": getMarkerKey(rightBcMarker, p.icon),
                }))
            },
            "ucl": {
                "measurementCondition": {
                    "transducer": 1
                },
                "measurementPoint": right[2] && right[2].points.map(p => ({
                    "frequency": p.x,
                    "level": p.y,
                    "qualification": getMarkerKey(rightUCLMarker, p.icon),
                }))
            }
        };
    }
    return result;
}
export function convert2RecdData(left, right) {
    return {
        "left": {
            "creationDate": moment().format(),
            "measurementPoints": left && left.length > 0 ? left[0].points.map(p => ({
                "frequency": p.x,
                "level": p.y,
            })) : [],
            "mold": "FoamEarTip",
            "transducer": "Undefined",
            "coupler": "Ha1"
        },
        "right": {
            "creationDate": moment().format(),
            "measurementPoints": right && right.length > 0 ? right[0].points.map(p => ({
                "frequency": p.x,
                "level": p.y,
            })) : [],
            "mold": "FoamEarTip",
            "transducer": "Undefined",
            "coupler": "Ha1"
        }
    };
}
export function convert2ReugData(left, right) {
    return {
        "left": {
            "measurementPoints": left && left.length > 0 ? left[0].points.map(p => ({
                "frequency": p.x,
                "level": p.y,
            })) : [],
            "creationDate": moment().format("YYYY-MM-DD"),
        },
        "right": {
            "measurementPoints": right && right.length > 0 ? right[0].points.map(p => ({
                "frequency": p.x,
                "level": p.y,
            })) : [],
            "creationDate": moment().format("YYYY-MM-DD"),
        }
    };
}

export function getCFPoints(data) {
    if (!data) return [];
    const centerFrequencies = data.centerFrequencies;
    const functionValues = data.functionValues;
    if (centerFrequencies?.length !== functionValues?.length) return [];

    const result = [];

    for (let i = 0; i < centerFrequencies.length; i++) {
        result.push({ x: centerFrequencies[i], y: functionValues[i] });
    }
    return result;
}

export const wx2userAdapter = (data) => {
    return {
      id: data.openid,
      avatar: data.headimgurl,
      bio: 'Sales Manager',
      canHire: false,
      country: data.country,
      email: 'katarina.smith@devias.io',
      username: data.nickname,
      password: 'admin',
      isPublic: true,
      phone: '+40 777666555',
      role: 'admin',
      city: data.city,
      gender: data.sex,
      timezone: '4:32PM (GMT-4)',
      dateOfBirth: new Date('2018-08-18T21:11:54')
    };
  };